class SendSMSRequest {

    getRequestSendSMS = (datosEnvioSMS) => {
        return {
            "datos": {
                "telefono": datosEnvioSMS.telefono
            }
        };
    }
}

export default SendSMSRequest;